import { render, staticRenderFns } from "./DiabetesCertificateCard.vue?vue&type=template&id=59ad4b75&scoped=true&"
import script from "./DiabetesCertificateCard.vue?vue&type=script&lang=js&"
export * from "./DiabetesCertificateCard.vue?vue&type=script&lang=js&"
import style0 from "./DiabetesCertificateCard.vue?vue&type=style&index=0&id=59ad4b75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad4b75",
  null
  
)

export default component.exports